import { BaseContent, ContentTypeEnum, Id } from '../../../types'

export enum PhoneContentDisplayEnum {
  Directory = 'directory',
  Telephone = 'telephone',
}

// export type PhoneContentDisplayType = `${PhoneContentDisplayEnum}`
export type PhoneContentDisplayType = PhoneContentDisplayEnum

export interface DirectoryContact {
  name?: string
  business?: string
  exchange: string
  number: string
  exchangeNumber: string
}

export interface PhoneContent extends BaseContent {
  type: `${ContentTypeEnum.Phone}`
  display?: PhoneContentDisplayType[]
}
